// extracted by mini-css-extract-plugin
export var discard = "_2q-3";
export var muiTooltipTooltip = "_2q-5";
export var notificationBar = "_2q-2";
export var saveButtonHoverSlotWrapper = "_2q-4";
export var show = "_2q-1";
export var spacer = "_2q-0";